"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreRefundReasonEnum = void 0;
/**
 * Причина возврата
 */
var BillingCoreRefundReasonEnum;
(function (BillingCoreRefundReasonEnum) {
  /**
   * Услуга не оказана.
   *
   * - преподаватель не начал оказание услуги.
   * - технические проблемы
   * - другие причины
   */
  BillingCoreRefundReasonEnum["SERVICE_NOT_PROVIDED"] = "SERVICE_NOT_PROVIDED";
  BillingCoreRefundReasonEnum["BUYER_REFUSED"] = "BUYER_REFUSED";
})(BillingCoreRefundReasonEnum = exports.BillingCoreRefundReasonEnum || (exports.BillingCoreRefundReasonEnum = {}));
